export { default } from './ForecastDayTable';
